import React from 'react';
import MissingFieldsTag from '../tags/MissingFieldsTag';
import useMissingFields from '../../pages/event-manage/useMissingFields';

export default function EventMissingFieldsTag(props) {
  const { event } = props;

  const { missingFields } = useMissingFields(event);

  if (missingFields.data.length > 0) {
    return (
      <MissingFieldsTag resource={event} />
    );
  }

  return null;
}
